import 'moment/locale/nb';
import React from 'react';
import {
  DropdownItem,
  RenderPartHightlightMatch,
  Separator,
} from 'src/components/SearchableDropdown';
import { motion } from 'framer-motion';
import { getBrandingColor, colorTypes, getBrandingStyleOverride } from 'src/branding';

import Modal from 'src/components/Modal';

import styled, { css } from 'styled-components';
import { Check } from '@rocketseat/unform';

import Button from 'src/components/Button';
import { InfoBubble } from 'src/components/InfoBubble';
import Helptext from 'src/components/Helptext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';
import { faTimes } from '@fortawesome/free-solid-svg-icons/index';
import {
  Page,
  Label,
  Column,
  Row,
  LinkLabel,
} from '../../components/Layout';
import { animalAddCommentVariants, errorMsgVariants, padMarkNo } from './util';
import { InputChoices } from '../../components/Input';
import { getAmountAnimalsInGroupWithoutHealthRemarkGroup } from './SpecifyHealthRemarks';
import { Completed as CompletedExtern } from '../Profile/ChangePassword';
import { healthRemarksIdsRequiresComment } from './Config';

export const SelectSheepCattleDropdownElem = ({
  searchTerm,
  item,
  itemHasFocus,
  itemIsChoosed,
}) => (
  <DropdownItem
    itemHasFocus={itemHasFocus}
    itemIsChoosed={itemIsChoosed}
    style={{ paddingLeft: '1.5em' }}
    fontSize="1.1em"
  >
    {itemIsChoosed && (
      <Label
        size="1.2em"
        aria-label="Valgt"
        marginLeft="0.5em"
        style={{ position: 'absolute', left: '0' }}
      >
        <span aria-hidden="true">✓</span>
      </Label>
    )}
    <RenderPartHightlightMatch
      contentStyle={{
        display: 'inline-block',
        marginTop: '0.1em',
        marginRiight: '0.7em',
        marginLeft: '0em',
      }}
      part={padMarkNo(item.mark_no)}
      contentWrapperStyle={{
        flexBasis: 'unset',
        marginRight: '25px',
        width: '5em',
      }}
      highlightedPartStyle={{
        marginLeft: '0',
      }}
      searchTerm={searchTerm.replace(/ /g, '').split('/')[0]}
    />
    <Separator
      style={{ position: 'absolute', left: '6.9em', alignSelf: 'center' }}
    >
      /
    </Separator>
    <RenderPartHightlightMatch
      contentStyle={{ display: 'inline-block', marginTop: '0.1em', marginLeft: '0.1em' }}
      contentWrapperStyle={{ flexBasis: 'unset' }}
      part={item.individual_no}
      highlightedPartStyle={{
        marginLeft: '0',
      }}
      searchTerm={searchTerm.replace(/ /g, '').split('/')[searchTerm.split('/').length - 1]}
    />
    <RenderPartHightlightMatch
      contentStyle={{
        display: 'inline-block',
        marginTop: '0.1em',
        marginLeft: '0.15em',
      }}
      contentWrapperStyle={{
        flexBasis: 'unset',
        marginLeft: 'auto',
        marginRight: '37px',
      }}
      part={`f:${item.birthdate}`}
      searchTerm={searchTerm}
    />
  </DropdownItem>
);

export const DropdownElem = ({
  searchTerm,
  item,
  itemHasFocus,
  itemIsChoosed,
  disableHighlightMatchOnSearch,
  wrapText,
}) => (
  <DropdownItem
    itemHasFocus={itemHasFocus}
    itemIsChoosed={itemIsChoosed}
    style={{ paddingLeft: '1.5em' }}
    fontSize="1.1em"
  >
    {itemIsChoosed && (
      <Label
        size="1.2em"
        aria-label="Valgt"
        marginLeft="0.5em"
        style={{ position: 'absolute', left: '0' }}
      >
        <span aria-hidden="true">✓</span>
      </Label>
    )}
    <RenderPartHightlightMatch
      contentStyle={{
        display: 'inline-block',
        marginTop: '0.1em',
        marginLeft: '0.15em',
      }}
      contentWrapperStyle={{
        flexBasis: 'unset',
        marginRight: '37px',
      }}
      part={item.text}
      disableHighlightMatchOnSearch={disableHighlightMatchOnSearch}
      searchTerm={searchTerm}
      wrapText={wrapText}
    />
  </DropdownItem>
);

export const MedicationInfo = (med) => (
  <div style={{ marginBottom: '1.2em' }}>
    <Label marginLeft="1.5em">
      Navn:
      {med.med.name}
    </Label>
    <Label marginLeft="1.5em">
      Siste behandling:
      {' '}
      {med.med.treatment_date}
    </Label>
    <Label marginLeft="1.5em">
      Siste tilbakeholdsdato:
      {' '}
      {med.med.restrain_limit}
    </Label>
  </div>
);

export const AddNewRowHeader = ({ children }) => (
  <Label size="2.5em" font="serif" marginTop="2rem">
    {children}
  </Label>
);

export const Errors = ({ errors, variants }) => (
  <motion.div
    variants={variants || errorMsgVariants}
    initial="collapsed"
    animate={
    errors
      ? 'visible'
      : 'collapsed'
}
  >
    <ErrorMsg>
      {errors}
    </ErrorMsg>
  </motion.div>
);

export const RegNotAvailibleInfo = ({ header, subject, description }) => (
  <RegNotAvailible>
    {header
  && <h2>{header}</h2> }
    {subject
  && (
    <p name="subject">
      {subject}
    </p>
  ) }
    {description
  && (
    <p name="desc">
      {description}
    </p>
  ) }
  </RegNotAvailible>
);

export const AddCommentToggleButton = ({
  centerComment,
  onToggleComment,
  customTxt,
  ...props
}) => (
  <AddCommentButtonStyled center={centerComment} onClick={onToggleComment} {...props}>
    {customTxt ? customTxt : 'Legg til kommentar'}
  </AddCommentButtonStyled>
);
export const EditComment = ({
  showComment,
  onChangeComment,
  onToggleComment,
  comment,
  centerComment,
  commentWidth,
  maxLength,
  style,
  commentProps,
  ...props
}) => (
  <div style={{ width: '100%', ...style }} {...props}>
    <motion.div
      initial="collapsed"
      animate={showComment ? 'visible' : 'collapsed'}
      variants={animalAddCommentVariants}
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <AnimalRowAddComment
        width={commentWidth}
        value={comment || ''}
        onChange={(evt) => onChangeComment(evt.target.value)}
        {...commentProps}
        style={{
          ...commentProps?.style || {}, position: 'static', marginLeft: 'auto', marginRight: 'auto', transform: 'none',
        }}
      />
      <Label
        style={{
          textAlign: 'center',
          color:
              comment && comment.length > maxLength
                ? getBrandingColor(colorTypes.error)
                : '#4a4a4a',
        }}
      >
        {`${comment ? comment.length : 0} av ${maxLength} tegn`}
      </Label>
    </motion.div>
  </div>
);

export const AnimalRowCheckmark = ({ style }) => (
  <Label
    size="1.5em"
    aria-label="Valgt"
    style={{ position: 'relative', left: '0.4em', ...style || {} }}
  >
    <span aria-hidden="true">✓</span>
  </Label>
);

export const CheckboxForCattleOption = ({
  currentAnimalRow,
  cattleKey,
  animalRowMode,
  label,
  onCheck,
  dataKey,
  withInfoBubble,
}) => (
  <CheckboxWithInfoBubble
    name={`${dataKey}: ${
      animalRowMode === 'add'
        ? currentAnimalRow.cattle[cattleKey].individual_no
            + currentAnimalRow.cattle[cattleKey].mark_no
        : currentAnimalRow.individual_no
    }${currentAnimalRow.mark_no}`}
    label={label}
    checked={
        animalRowMode === 'add'
          ? currentAnimalRow.cattle[cattleKey][dataKey] || false
          : currentAnimalRow[dataKey] || false
      }
    onChange={(evt) => onCheck(evt.target.checked, cattleKey, dataKey)}
    infoBubbleHelptextKey={withInfoBubble?.key}
  />
);

export const RegisterStep = React.memo(({
  stepNo,
  stepHeader,
  stepSubheader,
  name,
  selectedValue,
  values,
  choices,
  disabledValues,
  onChange,
  onGetRef,
  smallInputChoices,
  inputChoicesWidth,
  inputChoicesJustity,
  inputChoicesTopMargin,
  children,
  ...props
}) => (
  <StepWrapper
    borderRadius="0.5em"
    background="#F9F9F9"
    padding="1.5em 2.5em"
    {...props}
    ref={(ref) => {
      if (onGetRef) {
        onGetRef(ref);
      }
    }}
    marginTop="2em"
  >
    <Row>
      <Label size="2em" font="serif">
        {stepNo}
        .
      </Label>
      <Label
        bold
        align="flex-end"
        size="1em"
        marginLeft="1em"
        marginBottom="0.3em"
      >
        {stepHeader}
        {stepSubheader
        && (
          <>
            <br />
            <p style={{ fontStyle: 'italic', marginTop: '0.7rem', fontWeight: 'normal' }}>{stepSubheader}</p>
          </>
        )}
      </Label>
    </Row>
    {choices && (
      <Row marginTop={inputChoicesTopMargin || '1em'}>
        <InputChoices
          flexBasis={inputChoicesWidth || '33%'}
          justify={inputChoicesJustity || 'center'}
          name={name}
          small={smallInputChoices}
          choices={choices}
          values={values}
          value={selectedValue}
          disabledValues={disabledValues}
          onChange={onChange}
        />
      </Row>
    ) }
    {children}
  </StepWrapper>
));

export const HoverRow = styled(Row)`
  :hover {
    cursor: pointer;
  }
`;

export const StyledSlaktewebIcon = styled.i`
  font-size: 2em;
  margin-right: 0.5em;
  ::before {
    position: relative;
    top: 50%;
  }
`;
export const SmallInputField = styled.input`
  width: 4em;
  text-align: center;
  padding-left: 0;
  padding-right: 0;
  ${({ valid }) => (!valid ? `color: ${getBrandingColor(colorTypes.error)}` : '')};
  ${({ valid }) => (!valid ? 'font-weight: bold' : '')};

  /*Safari only*/
  _:not(a,b), &{ 
    border: 1px solid gray;
    border-radius: 4px;
  }
`;

export const Checkbox = styled(Check)`
  position: absolute;
  line-height: 2.1ex;
  left: -999em;
  margin-bottom: 0.9em;

  ${({ disabled }) => disabled && css`
    & + label{
      cursor: default !important;
    }
  `}

  ${({
  big, medium, inline, labelStyle, customColor, customMarginRight, customMarginLeft,
}) => (big
  ? css`
          &:checked + label:after {
            content: '';
            position: absolute;
            width: 1.4ex;
            height: 0.45ex;
            background: rgba(0, 0, 0, 0);
            left: 0.8ex;
            top: 50%;
            border: 0.6ex solid ${customColor ? customColor : getBrandingColor(colorTypes.primary)};
            border-top: none;
            border-right: none;
            -moz-transform: translateY(-67%) rotate(-45deg);
            -o-transform: translateY(-67%) rotate(-45deg);
            transform: translateY(-67%) rotate(-45deg);
            flex: 0 0 auto;
          }

          & + label {
            position: relative;
            cursor: pointer;
            display: ${inline ? 'inline-flex' : 'flex'};
            flex-direction: row;
            align-items: center;
            ${({ maxWidthLabel }) => (maxWidthLabel ? `max-width:${maxWidthLabel};` : '')}

            > {
              flex: 1 1 auto;
            }

            margin-left: ${customMarginLeft ? customMarginLeft : '0'};
            ${labelStyle || ''};

            &:before {
              content: '';
              display: block;
              vertical-align: -25%;
              height: 3.5ex;
              width: 3.5ex;
              background-color: ${getBrandingColor(colorTypes.whiteAltBg)};
              border: 1.115px solid rgba(78, 122, 185, 0.22);
              border-radius: 0.3em;
              margin-right: ${customMarginRight ? customMarginRight : '0.6em'};
              box-sizing: border-box;
              flex: 0 0 auto;
            }
          }
        `
  : medium
    ? css`
          &:checked + label:before {
            content: '';
            position: absolute;
            width: 1.2ex;
            height: 0.45ex;
            background: rgba(0, 0, 0, 0);
            right: 0.5ex;
            top: 50%;
            border: 0.4ex solid ${getBrandingColor(colorTypes.primary)};
            border-top: none;
            border-right: none;
            -moz-transform: translateY(-67%) rotate(-45deg);
            -o-transform: translateY(-67%) rotate(-45deg);
            transform: translateY(-67%) rotate(-45deg);
          }

          & + label {
            position: relative;
            overflow: hidden;
            cursor: pointer;

            ${labelStyle || ''};

            &:after {
              content: '';
              display: inline-block;
              vertical-align: -25%;
              height: 2.8ex;
              width: 2.8ex;
              background-color: ${getBrandingColor(colorTypes.whiteAltBg)};
              border: 1.115px solid rgba(78, 122, 185, 0.22);
              border-radius: 0.3em;
              margin-left: 0.6em;
              box-sizing: border-box;
            }
          }
        `
    : css`
          &:checked + label:before {
            content: '';
            position: absolute;
            width: 1.2ex;
            height: 0.4ex;
            background: rgba(0, 0, 0, 0);
            right: 0.4ex;
            top: 50%;
            border: 0.4ex solid ${getBrandingColor(colorTypes.primary)};
            border-top: none;
            border-right: none;
            -moz-transform: translateY(-67%) rotate(-45deg);
            -o-transform: translateY(-67%) rotate(-45deg);
            transform: translateY(-67%) rotate(-45deg);
          }

          & + label {
            position: relative;
            overflow: hidden;
            cursor: pointer;

            ${labelStyle || ''};

            &:after {
              content: '';
              display: inline-block;
              vertical-align: -25%;
              height: 2.4ex;
              width: 2.4ex;
              background-color: ${getBrandingColor(colorTypes.whiteAltBg)};
              border: 1.115px solid rgba(78, 122, 185, 0.22);
              border-radius: 0.3em;
              margin-left: 0.6em;
              box-sizing: border-box;
            }
          }
        `)}

        ${({ isReceiptMode }) => isReceiptMode && css`
        &, &:checked + label:before,  & + label:after,& + label:before  {
          background: white;
          border: none;
        }
        `}
`;

const DisabledCheckWrapper = styled.div`
  background-color: ${getBrandingColor(colorTypes.whiteAltBg)};
  border: 1.115px solid rgba(78, 122, 185, 0.22);
  height: 3.5ex;
  width: 3.5ex;
  box-sizing: border-box;
  border-radius: 0.3em;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.6em;

  &:hover{
    cursor:not-allowed;
  }
  ${({ isReceiptMode }) => isReceiptMode && css`
  border: none;
  background: none;
  &:hover{
    cursor: default; 
  }
  `}
`;

const DisabledCheckContent = styled.div`
    color: #b0b0b0;
    font-size: 1.15rem;
`;

export const BigDisabledCheckbox = ({ isReceiptMode }) => (
  <DisabledCheckWrapper isReceiptMode={isReceiptMode}>
    <DisabledCheckContent>
      <FontAwesomeIcon icon={faTimes} />
    </DisabledCheckContent>
  </DisabledCheckWrapper>
);

export const AnimalRowFieldName = styled(Label)`
  margin-right: 0.4em;
  font-weight: bold;
  display: flex;
`;

export const AnimalRowFieldValue = ({ children, ...props }) => (
  <div name="valuePart" {...props}>
    <Label>{children}</Label>
  </div>
);

export const NoBold = styled.span`
  font-weight: normal;
`;

const StyledInputError = styled.p`
  color: ${getBrandingColor(colorTypes.error)};
  position: absolute;
  right: ${({ right }) => right};
  margin-right: 1em;
  margin-top: ${({ top }) => top};
  width: 'min-content';
  font-size: '0.9em';
  background: white;
`;

export const InputError = ({
  message, top, right = '0', ...props
}) => (
  <StyledInputError top={top} right={right} {...props}>
    {message}
  </StyledInputError>
);

export const AnimalKindIcon = React.memo(({ kind }) => (
  <Row
    align="center"
    justify="center"
    style={{ height: '3em' }}
  >
    <StyledSlaktewebIcon
      className={{
        pigs: 'sw-icon icon-gris',
        sheep: 'sw-icon icon-smafe',
        cattle: 'sw-icon icon-storfe',
      }[kind]}
      style={{
        pigs: {
          fontSize: '2.3em',
          position: 'relative',
          top: '0.08em',
        },
        sheep: { position: 'relative', top: '0.08em' },
        cattle: { position: 'relative', top: '0.07em' },
      }[kind]}
    />
    <AnimalGroupTxt>{{ pigs: 'Gris', sheep: 'Småfe', cattle: 'Storfe' }[kind]}</AnimalGroupTxt>
  </Row>
));

export const ErrorMsg = styled.p`
  line-height: 1.75;
  text-align: center;
  padding: 0.6rem 2rem;
  border: 1px solid ${getBrandingColor(colorTypes.error)};
  border-radius: 15px;
  z-index: 2;
  margin: 1rem;
  margin-left: 0;
  margin-right: 0;
  background: white;
  position: relative;

  width: fit-content;
  left: 50%;
  transform: translateX(-50%);
  color: ${getBrandingColor(colorTypes.error)};
  font-size: 0.9rem;
  box-sizing: border-box;

  @media screen and (max-width: 500px) {
    width: 90%;
    padding: 0.1em;
  }
`;

export const InfoBox = styled.div`
  border: 1px solid gray;
  line-height: 1.75;
  text-align: center;
  padding: 1rem;
  border: 1px solid #4a4a4a;
  border-radius: 15px;
  z-index: 2;
  margin: 1rem;
  margin-bottom: 0;
  max-width: 84%;
  margin-left: 0;
  margin-right: 0;
  background: white;
  position: relative;
  padding-bottom: 1.41em;
  margin-top: 3em;

  ${getBrandingStyleOverride('text')}


  p, h2, h3, h4{
    text-align: left;
    margin-top: 0;
    font-size: 1.1rem;
  }
  h2,h3,h4{
    margin-bottom: 0em;
  }
  a{
    color: ${getBrandingColor(colorTypes.primary)}
  }
  p:not(:last-child){
    margin-bottom: 1.2em;
  }

  p.box-header{
    ${getBrandingStyleOverride('headerText')}
    text-align: center;
    margin-bottom: 0.5em;
    font-size: 1.3rem;
  }


  width: fit-content;
  font-size: 1.1rem;

  @media screen and (max-width: 500px) {
    width: 90%;
  }

`;

export const StepWrapper = styled(Column)`
  @media screen and (max-width: 520px) {
    min-width: 88%;
    max-width: calc(100% - 2em);
  }

  @media screen and (max-width: 520px) {
    max-width: 200px;
    &.return-form-step-wrapper{
      max-width: none;
      padding: 1.5em 1.2em;
    }
  }
`;

export const AddCommentMixin = css`
  display: block;
  margin-top: 0.8rem;
  color: ${getBrandingColor(colorTypes.primary)};
  position: relative;
  ${({ center }) => (center
  ? `
  left: 50%;
  transform: translateX(-50%);
  `
  : '')}
  width: fit-content;
  text-align: center;
  margin-top: 0;
  margin-bottom: 0.7rem;
  text-decoration: underline;
`;
export const AddCommentButton = styled(LinkLabel)`
  ${AddCommentMixin}
`;

export const AddCommentButtonStyled = styled.button`
  border: none;
  font-size: 1em;
  background: none;
  ${AddCommentMixin} :hover {
    cursor: pointer;
  }
  :active,
  :focus,
  :active:focus {
    outline: none;
  }
`;

export const ErrorCont = styled(ErrorMsg)`
  color: #4a4a4a;
  text-align: left;
  max-width: 84%;
  margin-left: 0;
  margin-right: 0;
  font-size: 1.1em;
  margin-top: 2em;
`;

export const ErrorContHeader = styled(Label)`
  text-align: center;
  font-size: 1.3em;
  text-decoration: underline;
  margin-bottom: 0.5em;
`;

export const RegNotAvailible = styled.div`
  margin-left: 0.5em;

  [name='desc'] {
    margin-top: 1em;
    margin-bottom: 5em;
    font-size: 1.2em,
  }

  [name="subject"]{
    margin-top: 2em;
    font-size: 1.5em;
  }
`;

export const AnimalGroupTxt = styled.p`
  align-self: center;
  margin: 0;
  margin-right: 1em;
`;

export const ChooseCattleWrapper = styled.div`
  width: 100%;
  @media screen and (max-width: 354px){
    margin-right: -1.35em;
    max-width: 108.1vw;
    min-width: 94.5vw;
  }

`;

export const CattleOriginMarkAndDelete = styled(Row)`
  @media screen and (max-width: 345px){
    width: 88%;
  }
`;

export const AnimalRowField = styled.div`
  margin-right: 1em;
  margin-bottom: 0.1em;
  display: flex;

  @media screen and (max-width: 500px) {
    [name='splitLinesOnMobile'] {
      flex-wrap: wrap;
      flex-basis: 0%; /*force on separate lines*/
    }
    [name='actionButtonsRow'] {
      max-width: 80%;
    }
  }
`;

export const ConfirmSwitchModal = styled(Modal)`
  [name='confirmModalConfirmButton'] {
    margin-left: 1em;
  }
  [name='buttonGroupConfirmModal'] {
    flex-direction: row;
  }
  @media screen and (max-width: 700px) {
    [name='buttonGroupConfirmModal'] {
      flex-direction: column;
    }
    [name='confirmModalConfirmButton'] {
      margin-left: 0;
    }
  }
`;

export const AnimalRowAddComment = styled.textarea`
  height: 140px;
  max-height: 360px;
  font-size: 1.1rem;
  width: 100%;
  box-sizing: border-box;
  margin-top: 0.7rem;
  border: 1px solid #dddada;
  border-radius: 3px;
  padding: 0.5rem;
  resize: vertical;

  max-width: 450px;
  align-self: center;
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  ${({ center }) => center && css`
    align-self: center;

    position: relative;
    left: 50%;
    transform: translateX(-50%);
  `}

  ${({ leftAlign }) => leftAlign && css`
    left: 0;
    transform: none;
  `}

  ${({ fullwidth }) => fullwidth && css`
      width: 100%;
    max-width: 99999px;
  `}


  ${({ isReceiptMode }) => isReceiptMode && css`
    border: none;
    font-family: 'Lato', sans-serif;
    height: auto;
    height: 156px;
    &:hover{
      cursor: default;
    }
    &:focus{
      outline: none;
    }
  `}
`;

export const IncrementDecrementBtn = styled(Label)`
  color: ${({ disabledBtn }) => (disabledBtn ? 'gray' : 'inherit')};
  :hover {
    cursor: ${({ disabledBtn }) => (disabledBtn ? 'not-allowed' : 'pointer')};
    pointer-events: all;
  }
  :active {
    pointer-events: ${({ disabledBtn }) => (disabledBtn ? 'none' : 'all')};
  }
`;

export const AnimalRowWrapper = styled(Column)`
  margin: auto;
  width: 100%;
  max-width: 960px;
  margin-left: 0;
  margin-right: 0;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.85em 0px;

  @media screen and (max-width: 400px) {
    left: 0%;
    transform: none;
  }
`;

export const AnimalRowInfo = ({
  label, value, noSpaceAfterLabel, withCheckmark, labelStyle, ...props
}) => (
  <AnimalRowField {...props}>
    {withCheckmark && (
      <>
        <AnimalRowFieldName>
          <AnimalRowCheckmark />
        </AnimalRowFieldName>
        {label && <AnimalRowFieldValue>{label}</AnimalRowFieldValue>}
      </>
    )
      || (
        <>
          {label && (
            <AnimalRowFieldName style={labelStyle}>
              {label}
              {!noSpaceAfterLabel ? ' ' : ''}
            </AnimalRowFieldName>
          )}
          {value && <AnimalRowFieldValue>{value}</AnimalRowFieldValue>}
        </>
      )}
  </AnimalRowField>
);

export const CheckmarkAndHeaderCont = styled.div`
  display: flex;
  margin-left: 1em;

  ${AnimalRowFieldName} {
    margin-left: 0;
  }
`;

export const MainHeaderWrapper = styled(Label)`
  /*IE*/
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    ${(props) => props.ieHeightAdjust && css`position: relative; bottom: 0.8em;`}
  }
`;

export const RegisterSlaughterPage = styled(Page)`
  padding-bottom: 5em;
  max-width: 1000px;
  width: 100%;

  align-self: center;
  [name='animalRowCattleMark'] {
    display: flex;
    flex-wrap: wrap;
  }
  [name='valuePart'] {
    float: right;
    margin-left: 0.35em;
  }

  @media screen and (max-width: 400px) {
    padding-left: 1em;
    padding-right: 2em;

    [name='animalRowsAndAddNewPart'] {
      padding-left: 1em;
    }
  }

  @media screen and (max-width: 500px) {
    [name='animalRowDetails'] {
      flex-direction: column;
    }
  }
`;

export const EnrolmentInfoLink = styled.a`
      color: rgb(11, 71, 158);
      text-decoration: underline;
      margin-top: 1em;
      display: block;
      margin-bottom: 1em;
`;
export const MedicationWithHoldbackWithinWeekInfo = styled.div`
    margin-top: 1em;
    margin-bottom: 1em;
    max-width: 84%;
    font-size: 1.1rem;
    border-radius: 0.5em;
    background-color: rgb(249, 249, 249);
    padding: 1em 2.5em;

  @media screen and (max-width: 500px) {
    padding-left: 1.5em;
    padding-right: 1.5em;
    padding-top: 1em;
    margin-top: 1.5em;
  }
`;

export const ModalCancelButton = ({ ...props }) => (
  <Button
    secondary
    style={{ padding: '12px 41px', ...props.style || {} }}
    {...props}
  />
);

export const ModalDangerousActionButton = ({ style = {}, ...props }) => (
  <Button
    warn
    style={{ ...style, padding: '12px 41px' }}
    {...props}
  />
);

export const StepHeader = ({ text, ...props }) => (
  <Label
    bold
    align="flex-end"
    size="1em"
    marginLeft="1em"
    marginBottom="0.3em"
    {...props}
  >
    {text}
  </Label>
);

export const DiseasesList = ({ diseases }) => diseases.map((m) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      marginLeft: '1.5em',
    }}
  >
    <Label marginLeft="1em">
      Navn:
      {' '}
      {m.name}
    </Label>
    <Label marginLeft="1em">
      Kode:
      {' '}
      {m.code}
    </Label>
  </div>
));

export const animalKindToNorwegian = (gc) => {
  if (gc === 'cattle') {
    return 'Storfe';
  }
  if (gc === 'sheep') {
    return 'Småfe';
  }
  if (gc === 'pigs') {
    return 'Gris';
  }
};

export const ignoreYougPartOfCattleKind = (category) => category.toLowerCase().split('ung ').slice(-1)[0];

// some animals are prefixed with "ung" to indicate a young variant, this method removes this part on source and target and
// compares
export const subcategoryEqualsIgnoreAgePart = (source, target) => {
  if (target === 'all_kinds') {
    return true;
  }
  return source.toLowerCase().split('ung ').slice(-1)[0] === target.toLowerCase().split('ung').slice(-1)[0];
};

export const getErrorsTotAmountAnimalsInHealthRemarksGroup = (animalRow) => {
  // if the summed number of animals in each health remarks group for an
  // animal row is higher than the number of animals with helath remarks the
  // user specifired earlier, show some errors
  let totalCntAnimalsInHealthRemarkGroupsForGroup = null;
  const cntAnimalsWithRemarksForRow = parseInt(animalRow.health_remarks_cnt, 10);
  if (!animalRow.health_remarks_groups) {
    return undefined;
  }
  animalRow.health_remarks_groups.forEach((group) => {
    if (group.amount_animals) {
      if (!totalCntAnimalsInHealthRemarkGroupsForGroup) {
        totalCntAnimalsInHealthRemarkGroupsForGroup = 0;
      }
      totalCntAnimalsInHealthRemarkGroupsForGroup += parseInt(group.amount_animals, 10);
    }
  });
  if (totalCntAnimalsInHealthRemarkGroupsForGroup > cntAnimalsWithRemarksForRow) {
    return `Totalt antall dyr med helseavvik kan ikke være mer enn ${cntAnimalsWithRemarksForRow}.`;
  }
  return null;
};

export const getReturnSheep = (animalRow) => {
  if (animalRow.return_sheep) {
    return animalRow.return_sheep.filter(
      (e) => e.disabled === undefined || e.disabled === false,
    );
  } else {
    return [];
  }
};

export const AfterStepsItems = styled.div`
  margin: 1.1em auto 0em;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const CattleHealthRemarksWrapper = styled.div`
  @media (max-width: 380px){
    display: block;
  }
`;

export const CheckmarkLabel = styled(Label)`
margin-top: 11px;
display: flex;
`;
export const CheckmarkText = styled.div`

`;

export const getAllAnimalsSelectedWithHelthRemarksHasHelthRemarks = (animalRows, selectedAnimalGroup) => {
  let hasHealthRemarksNotYetSpecified = false;
  animalRows.filter((a) => a.has_health_remarks || a.health_remarks_cnt || getReturnSheep(a).find((rs) => rs.has_health_remarks)).forEach((a) => {
    const rowIsGroup = a.club_no || selectedAnimalGroup === 'sheep';
    if (rowIsGroup) {
      if (getReturnSheep(a).length > 0) {
        if (getReturnSheep(a).find((rs) => rs.has_health_remarks && !rs.health_remarks_code)) {
          hasHealthRemarksNotYetSpecified = true;
        }
      }
      if (getAmountAnimalsInGroupWithoutHealthRemarkGroup(a) > 0 || animalRows.find((ar) => ar.health_remarks_groups && ar.health_remarks_groups.find((g) => !g.health_remarks_code))) {
        hasHealthRemarksNotYetSpecified = true;
      }
    } else {
      if (!a.health_remarks_code) {
        hasHealthRemarksNotYetSpecified = true;
      }
    }
  });
  return hasHealthRemarksNotYetSpecified;
};

// some health remarks require the user to provide a comment
export const getHasRequiredCommentsForHealthRemarks = (animalRows, selectedAnimalGroup) => {
  let hasMissingComment = false;
  const checkHealthRemarkRow = (row) => !healthRemarksIdsRequiresComment.includes(row.health_remarks_code) || ((row.has_health_remarks || row.health_remarks_cnt || row.amount_animals)
    && healthRemarksIdsRequiresComment.includes(row.health_remarks_code) && row.health_remarks_comment?.length > 0);

  animalRows.filter((a) => a.has_health_remarks || a.health_remarks_cnt || getReturnSheep(a).find((rs) => rs.has_health_remarks)).forEach((a) => {
    const rowIsGroup = a.club_no || selectedAnimalGroup === 'sheep';
    if (rowIsGroup) {
      if (getReturnSheep(a).length > 0) {
        if (getReturnSheep(a).find((rs) => !checkHealthRemarkRow(rs))) {
          hasMissingComment = true;
        }
      }
      if (animalRows.find((ar) => ar.health_remarks_groups && ar.health_remarks_groups.find((g) => !checkHealthRemarkRow(g)))) {
        hasMissingComment = true;
      }
    } else {
      if (!checkHealthRemarkRow(a)) {
        hasMissingComment = true;
      }
    }
  });
  return !hasMissingComment;
};

export const getHasHealthRemarksWithRequiredComments = (animalRowsWithHealthRemarks) => !!animalRowsWithHealthRemarks.find(
  (ar) => (ar?.health_remarks_groups && ar.health_remarks_groups.find((g) => healthRemarksIdsRequiresComment.includes(g.health_remarks_code)))
  || (ar.health_remarks_code && healthRemarksIdsRequiresComment.includes(ar.health_remarks_code))
|| getReturnSheep(ar).find((rs) => healthRemarksIdsRequiresComment.includes(rs.health_remarks_code)),
);

export const Completed = ({ ...props }) => (
  <CompletedExtern style={{
    marginRight: '9px', display: 'flex', flexDirection: 'column-reverse', alignSelf: 'start', ...props.style,
  }}
  />
);

const CheckboxWithInfoBubbleWrapper = styled.div`
@media (max-width: 1100px){
  .info-bubble .popup{
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
    width: 19em;
  }
}
`;

export const CheckboxWithInfoBubble = ({
  infoBubbleHelptextKey, popupStyle = {}, popupStyleMobile = {}, name, label, checked, onChange, ...props
}) => (
  <CheckboxWithInfoBubbleWrapper>
    <Checkbox
      name={name}
      checked={checked}
      label={label}
      onChange={onChange}
      {...props}
    />
    {infoBubbleHelptextKey
    && (
      <Helptext
        name={infoBubbleHelptextKey}
        render={(text) => text
    && (
      <InfoBubble
        style={{
          position: 'relative',
          left: '0.35em',
          bottom: '0.1em',
        }}
        popupStyle={{
          position: 'absolute',
          top: '26px',
          left: '-120px',
          minWidth: '12em',
          ...popupStyle,
        }}
        popupStyleMobile={{ ...popupStyleMobile }}
      >
        <span dangerouslySetInnerHTML={{ __html: text }} />
      </InfoBubble>

    )}
      />
    )}
  </CheckboxWithInfoBubbleWrapper>
);

export const HorizontalCheckboxLine = styled.div`
  display: flex;
  .checkbox-wrapper{
    white-space: nowrap;
    display: inline;
    &:not(:last-child){
      margin-right: 1.2em;
    }
  }
  @media (max-width: 500px){
    .checkbox-wrapper:not(:last-child){
      margin-right: 0.6em;
    }
  }

  @media (max-width: 425px){
    ${({ wrapOnSmall }) => wrapOnSmall && css`
    flex-wrap: wrap;
    max-width: 95%;
    gap: 0.5em;
    `}
  }
`;

export const SlaugherSheepMainContentWrapper = styled(Column)`
  @media (max-width: 550px){
      min-width: 94.5vw;
      margin-right: -2.7em;
      width: 100%;
  }
`;

export const RegisteredReturnFormWrapper = styled.div`
background: #f4f1ec;
padding: 1.5em;

@media (max-width: 450px){
  padding-left: 0.75em;
  padding-right: 0.75em;
}
`;

export const ReturnFormWrapper = styled.div`
margin-top: 2em;
`;
